import React from "react";
import { FormProvider } from "react-hook-form";

import Styles from "./LegalPath.styles";
import { LegalPathProps as Props } from "./LegalPath.types";
import Button from "components/global/Button/Button";
import StepOneLegalForm from "./StepOneLegalForm/StepOneLegalForm";
import useCheckoutLegalForms from "../hooks/useCheckoutLegalForms";
import StepTwoLegalForm from "./StepTwoLegalForm/StepTwoLegalForm";
import StepThreeLegalForm from "./StepThreeLegalForm/StepThreeLegalForm";

import GoBackSVG from "../../../../../public/assets/images/anefi/go-back.svg";
import CloseModalSVG from "../../../../../public/assets/images/anefi/close-modal.svg";

const LegalPath: React.FC<Props> = props => {
  const { className } = props;
  const checkoutForms = useCheckoutLegalForms();
  const { handleSubmit, currentStep, setCurrentStep } = checkoutForms;
  const { onClose, stepOneFormMethods, stepTwoFormMethods } = checkoutForms;
  const { stepThreeFormMethods } = checkoutForms;

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <FormProvider {...stepOneFormMethods}>
            <StepOneLegalForm />
          </FormProvider>
        );
      case 2:
        return (
          <FormProvider {...stepTwoFormMethods}>
            <StepTwoLegalForm />
          </FormProvider>
        );
      case 3:
        return (
          <FormProvider {...stepThreeFormMethods}>
            <StepThreeLegalForm />
          </FormProvider>
        );
      default:
        return null;
    }
  };

  return (
    <Styles className={`LegalPath ${className}`}>
      <div className="LegalPath__stepper">
        {Array.from(new Array(3)).map((_, index) => (
          <div
            key={index}
            className={`LegalPath__step ${
              currentStep < index + 1 ? null : `LegalPath__step--active`
            } `}
          />
        ))}
      </div>
      <div
        className={
          currentStep === 1
            ? "LegalPath__optionContainer"
            : "LegalPath__optionsContainer"
        }
      >
        {currentStep === 1 ? null : (
          <GoBackSVG
            className="LegalPath__goBack"
            onClick={() => {
              setCurrentStep(currentStep - 1);
            }}
          />
        )}
        <CloseModalSVG
          className="LegalPath__closeModal"
          onClick={() => onClose()}
        />
      </div>
      {renderStep()}
      <div className="LegalPath__buttonContainer">
        <Button className="LegalPath__button" onClick={handleSubmit}>
          {currentStep === 3 ? "Guardar" : "Continuar"}
        </Button>
      </div>
    </Styles>
  );
};

LegalPath.defaultProps = {
  className: ""
};

export default LegalPath;
